export const unsetForeground = (self) => {
  const foreground_layer_el = self._getForegroundLayerElThrowable();
  while (foreground_layer_el.lastChild != null) {
    foreground_layer_el.removeChild(foreground_layer_el.lastChild);
  }
};
